// extracted by mini-css-extract-plugin
export default {"wrapper":"transform-component_wrapper__9+RJM","content":"transform-component_content__4oirq"};